import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=2665f035&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2665f035"]])

export default __exports__